class RutaOfferPrice extends HTMLElement {
  connectedCallback() {
    this.isStickyPrice = Boolean(this.closest('.sticky-add-to-cart__price'));
    if (this.dataset.context !== 'product' && !this.isStickyPrice) return;

    this.scope = this.closest('.shopify-section') || document;
    this.handlePurchaseOptionChange = this.handlePurchaseOptionChange.bind(this);
    this.scope.addEventListener('change', this.handlePurchaseOptionChange);

    this.observer = new MutationObserver(() => this.syncPurchaseOption());
    this.observer.observe(this.scope, { childList: true, subtree: true });
    this.syncPurchaseOption();
  }

  disconnectedCallback() {
    this.scope?.removeEventListener('change', this.handlePurchaseOptionChange);
    this.observer?.disconnect();
  }

  handlePurchaseOptionChange(event) {
    if (event.target instanceof HTMLInputElement && event.target.name === 'selling_plan') {
      this.syncPurchaseOption();
    }
  }

  syncPurchaseOption() {
    const selectedPlan = this.scope?.querySelector('.appstle_sub_widget input[name="selling_plan"]:checked');
    if (!(selectedPlan instanceof HTMLInputElement)) return;
    const purchaseOption = selectedPlan.value ? 'subscription' : 'one-time';
    this.dataset.purchaseOption = purchaseOption;

    if (this.isStickyPrice) {
      this.syncStickyPrice(purchaseOption);
    }
  }

  syncStickyPrice(purchaseOption) {
    const mainOffer = [...this.scope.querySelectorAll('ruta-offer-price[data-context="product"]')].find(
      (offer) => offer !== this
    );
    const sourceOption = mainOffer?.querySelector(`[data-ruta-option="${purchaseOption}"]`);
    const sourceRegular = sourceOption?.querySelector('.ruta-price-offer__regular');
    const sourcePrice = sourceOption?.querySelector('.ruta-price-offer__price');
    const targetRegular = this.querySelector('.ruta-price-offer__regular');
    const targetPrice = this.querySelector('.ruta-price-offer__price');

    if (sourceRegular && targetRegular && sourceRegular.innerHTML !== targetRegular.innerHTML) {
      targetRegular.innerHTML = sourceRegular.innerHTML;
    }

    if (sourcePrice && targetPrice && sourcePrice.innerHTML !== targetPrice.innerHTML) {
      targetPrice.innerHTML = sourcePrice.innerHTML;
    }
  }
}

if (!customElements.get('ruta-offer-price')) {
  customElements.define('ruta-offer-price', RutaOfferPrice);
}
